import React, { useState, useEffect } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

/**
 * StripeWrapper component for handling subscription checkout
 * 
 * This component now supports two modes:
 * 1. Legacy embedded checkout (used for existing subscribers)
 * 2. Pricing table is now handled directly in the billing.html.haml view
 */
const StripeWrapper = ({ familyId, formToken, initialPriceId }) => {
  const [clientSecret, setClientSecret] = useState(null);
  const stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_KEY);

  useEffect(() => {
    async function initializeCheckout() {
      try {
        const promotekitReferral = window.promotekit_referral || null;

        const response = await fetch("/subscriptions/create.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": formToken,
          },
          body: JSON.stringify({
            price_id: initialPriceId,
            family_id: familyId,
            promotekit_referral: promotekitReferral,
          }),
        });

        const data = await response.json();

        if (data.clientSecret) {
          setClientSecret(data.clientSecret);
        } else {
          console.error("No client secret returned from the backend");
        }
      } catch (error) {
        console.error("Error fetching client secret:", error);
      }
    }

    // Only initialize the embedded checkout for existing subscribers
    // New subscribers will use the pricing table in the view
    initializeCheckout();
  }, [familyId, formToken, initialPriceId]);

  useEffect(() => {
    if (clientSecret && stripePromise) {
      stripePromise.then((stripe) => {
        stripe
          .initEmbeddedCheckout({
            clientSecret,
          })
          .then((checkout) => {
            const checkoutElement = document.getElementById("checkout");
            if (checkoutElement) {
              checkout.mount("#checkout");
            }
          })
          .catch((error) => {
            console.error("Error initializing embedded checkout", error);
          });
      });
    }
  }, [clientSecret]);

  return (
    <Elements stripe={stripePromise}>
      <div className="max-w-4xl mx-auto mt-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Manage Your Subscription</h1>
          <p className="text-xl text-gray-600">View or update your subscription details below</p>
        </div>
        <div id="checkout" className="bg-white rounded-lg shadow-md p-6 border border-gray-200"></div>
      </div>
    </Elements>
  );
};

export default StripeWrapper;
